import { ofType } from "redux-observable";
import { of } from "rxjs";
import { filter, switchMap, switchMapTo } from "rxjs/operators";
import { selectCoopActiveProjectExpired } from "../../../selectors/selectCoopInfo";
import { utilTick } from "../../../utils/utilTick";
import { TypeActionApp } from "../../app/actionApp";
import { actionCoopInfoResetProject } from "../../cooperative/actionCoop";
export var epicTimeCoopProject = function (action$, state$) {
    return action$.pipe(ofType(TypeActionApp.Init), switchMapTo(utilTick.second$), filter(function () { return selectCoopActiveProjectExpired(state$.value); }), switchMap(function () { return of(actionCoopInfoResetProject()); }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/time/epics/epicTimeCoopProject.ts
// module id = 2433
// module chunks = 3